import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

export interface SessionSupersededDialogData {
  hasUnsavedWork: boolean;
}

@Component({
  selector: 'app-session-superseded-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule
  ],
  template: `
    <div class="session-superseded-dialog">
      <div class="dialog-icon">
        <mat-icon>phonelink_erase</mat-icon>
      </div>
      <h2 mat-dialog-title>{{ 'SESSION_SUPERSEDED_DIALOG.TITLE' | translate }}</h2>
      <mat-dialog-content>
        <p>{{ 'SESSION_SUPERSEDED_DIALOG.MESSAGE' | translate }}</p>
        @if (data.hasUnsavedWork) {
          <p class="unsaved-warning">{{ 'SESSION_SUPERSEDED_DIALOG.UNSAVED_WORK' | translate }}</p>
        }
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        @if (data.hasUnsavedWork) {
          <button mat-raised-button color="accent" (click)="saveAndLogin()">
            <mat-icon>save</mat-icon>
            {{ 'SESSION_SUPERSEDED_DIALOG.SAVE_AND_LOGIN' | translate }}
          </button>
        }
        <button mat-raised-button color="primary" (click)="login()">
          <mat-icon>login</mat-icon>
          {{ 'SESSION_SUPERSEDED_DIALOG.LOGIN_BUTTON' | translate }}
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .session-superseded-dialog {
      text-align: center;
      padding: 20px;
    }

    .dialog-icon {
      margin-bottom: 16px;

      mat-icon {
        font-size: 64px;
        width: 64px;
        height: 64px;
        color: #ff9800;
      }
    }

    h2 {
      margin: 0 0 16px 0;
      color: #333;
      font-weight: 500;
    }

    mat-dialog-content {
      p {
        margin: 0 0 8px 0;
        color: #666;
        font-size: 14px;

        &.unsaved-warning {
          color: #e65100;
          font-size: 13px;
          font-weight: 500;
        }
      }
    }

    mat-dialog-actions {
      margin-top: 24px;
      gap: 12px;

      button {
        min-width: 150px;

        mat-icon {
          margin-right: 8px;
        }
      }
    }
  `]
})
export class SessionSupersededDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<SessionSupersededDialogComponent>);
  public readonly data: SessionSupersededDialogData = inject(MAT_DIALOG_DATA);

  saveAndLogin(): void {
    this.dialogRef.close('save_and_login');
  }

  login(): void {
    this.dialogRef.close('login');
  }
}
